/**
 * FIX: page zoom — iOS Safari ignores viewport user-scalable=no; block page pinch/double-tap zoom.
 * Exempt product image lightbox (zoom-dialog) so drag-zoom-wrapper pinch/pan still works.
 */
(function () {
  if (window.__iosPreventPageZoomInit) return;
  window.__iosPreventPageZoomInit = true;

  var DOUBLE_TAP_MS = 300;
  var DOUBLE_TAP_MAX_DISTANCE = 30;
  var lastTap = { time: 0, x: 0, y: 0 };

  var INTERACTIVE_SELECTOR =
    'a, button, input, select, textarea, label, summary, [data-quick-view-trigger], [role="button"], [contenteditable="true"]';

  /** @param {EventTarget | null} target */
  function isInsideZoomLightbox(target) {
    return target instanceof Element && !!target.closest('zoom-dialog');
  }

  /** @param {EventTarget | null} target */
  function isInteractiveTarget(target) {
    return target instanceof Element && !!target.closest(INTERACTIVE_SELECTOR);
  }

  /** @param {Event} event */
  function blockUnlessLightbox(event) {
    if (isInsideZoomLightbox(event.target)) return;
    event.preventDefault();
  }

  document.addEventListener('gesturestart', blockUnlessLightbox, { passive: false });
  document.addEventListener('gesturechange', blockUnlessLightbox, { passive: false });
  document.addEventListener('gestureend', blockUnlessLightbox, { passive: false });

  document.addEventListener(
    'touchend',
    function (event) {
      if (isInsideZoomLightbox(event.target)) return;
      if (isInteractiveTarget(event.target)) {
        lastTap.time = 0;
        return;
      }

      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;

      var now = Date.now();
      var elapsed = now - lastTap.time;
      var dx = Math.abs(touch.clientX - lastTap.x);
      var dy = Math.abs(touch.clientY - lastTap.y);

      if (elapsed > 0 && elapsed < DOUBLE_TAP_MS && dx < DOUBLE_TAP_MAX_DISTANCE && dy < DOUBLE_TAP_MAX_DISTANCE) {
        event.preventDefault();
        lastTap.time = 0;
        return;
      }

      lastTap.time = now;
      lastTap.x = touch.clientX;
      lastTap.y = touch.clientY;
    },
    { passive: false }
  );
})();
